<template>
  <div class="navbar">
    <div class="container">
      <div class="nav-left">
        <hamburger :is-active="sidebar.opened" class="hamburger-btn nav-item" @toggleClick="toggleSideBar"/>
        <brand class="brand nav-item"/>
      </div>
      <div class="nav-right text-right">
        <div v-if="isShowChromeTip" class="showChromeTip">
          请勿使用IE11及IE11以下浏览器，建议Google Chome【<a target="_blank" href="https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&ch=&tn=baiduerr&bar=&wd=google+chrome">点击下载</a>】
        </div>
        <el-menu class="navmenu" mode="horizontal">
          <message/>
          <my-account class="my-account"/>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Brand from './Brand'
import Hamburger from '@/components/Hamburger'
import Message from './Message'
import MyAccount from './MyAccount'

export default {
  components: {
    Hamburger,
    Brand,
    Message,
    MyAccount
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    isShowChromeTip() {
      const USER_AGENT = navigator.userAgent.toLowerCase()
      const isChrome = /.*(chrome)\/([\w.]+).*/
      return !isChrome.test(USER_AGENT)
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$height: 50px;
$bgColor: #2287f0;
$hoverBgColor: #66b1ff;
.navbar {
  position:fixed;
  height:$height;
  width:100%;
  background:$bgColor;
  box-sizing:border-box;
  border-bottom:solid 1px #f2f2f2;
  overflow: hidden;
  > .container {
    position:relative;
    height:$height;
  }
  .nav-left, .nav-right {
    height:$height;
  }
  .nav-right {
    position:absolute;
    height:$height;
    width:60%;
    right:0;
    top:0;
    bottom:0;
  }
  .text-right {
    text-align:right;
  }
  .nav-item {
    display:inline-block;
    height:$height;
  }
  .hamburger-btn {
    width:50px;
    line-height:50px;
    text-align:center;
    &:hover {
      background:$hoverBgColor;
    }
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      line-height: initial;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .el-menu {
    background:transparent;
    display:inline-block;
    border-width: 0;
  }
  .el-menu--horizontal > .el-menu-item {
    height:$height;
    line-height:$height;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    background:$hoverBgColor;
  }
  .el-submenu__title:hover {
    background:transparent;
  }
  .el-badge .el-button {
    margin-top: -5px !important;
  }
  .showChromeTip {
    position: absolute;
    font-size:16px;
    color:#fff;
    top: 14px;
  }
}
</style>

